module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/184.4262126d.png";